module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "svg-sprite-f0666e191f9085fc3de3ed484b6b7fae.svg#twitter",
      toString: function () {
        return this.url;
      }
    }